import router from '../routes/index'
import deepCopy from './deepCopy'

const routeHelper = {
  addBeforeEnterRecursive (routerConfigurationObject, beforeEnterCb = null) {
    if (!beforeEnterCb) {
      return
    }
    if (routerConfigurationObject && routerConfigurationObject.routes) {
      this._addBeforeEnter(routerConfigurationObject.routes, beforeEnterCb)
    }
  },
  _addBeforeEnter (route, beforeEnterCb) {
    if (route) {
      route.forEach((v, i) => {
        route[i].beforeEnter = beforeEnterCb
        if (v.children) {
          this._addBeforeEnter(route[i].children, beforeEnterCb)
        }
      })
    }
  },
  _flatRoutes: null,
  /**
   * @param router
   * @returns {Object} {name1: {}, name2: {}}
   */
  getFlatTree () {
    if (!this._flatRoutes) {
      let copy = (router.options.routes || []).slice()
      this._flatRoutes = {}
      copy.forEach(v => {
        this._flatRoutes[v.name] = v
        if (v.children) {
          let obj = {}
          obj = this._buildFlatTree(v.children, obj, v)
          for (let key in obj) {
            obj[key].root = v
          }
          this._flatRoutes = Object.assign(
            this._flatRoutes,
            obj
          )
        }
        this._flatRoutes[v.name].root = v
      })
    }
    return deepCopy(this._flatRoutes)
  },
  _buildFlatTree (router, fullOut, parent = null) {
    let out = fullOut || {}
    router.forEach(v => {
      out[v.name] = Object.assign({}, {
        name: v.name,
        meta: v.meta || null,
        children: v.children || []
      })
      if (parent) {
        out[v.name].parent = parent
      }
      if (v.children) {
        out = this._buildFlatTree(v.children, out, out[v.name])
      }
    })
    return out
  }
}

export default routeHelper
